// extracted by mini-css-extract-plugin
module.exports = {"socialGroupTitle":"SocialLoginPanel_socialGroupTitle__LaVSA","socialButton":"SocialLoginPanel_socialButton__CSNis","buttons":"SocialLoginPanel_buttons__U2jhg"};